import * as React from 'react';

import { EMetroTravelType } from '../../../../json_query';
import { TagNew } from '../TagNew';

const style = require('./index.css');

export interface IUndergroundTravelProps {
  travelType: EMetroTravelType | undefined;
  travelTime: number | undefined;
  onDelete(): void;
}

export const UndergroundTravel: React.FC<IUndergroundTravelProps> = ({ travelTime, travelType, onDelete }) => {
  return (
    <div className={style['container']}>
      <TagNew onDeleteClick={onDelete}>{getButtonLabel(travelType, travelTime)}</TagNew>
    </div>
  );
};

function getButtonLabel(travelType: EMetroTravelType | undefined, travelTime: number | undefined) {
  if (travelType === undefined && travelTime === undefined) {
    return 'Расстояние до метро';
  }

  return `До метро${travelTime !== undefined ? ` ${travelTime} мин.` : ''}${
    travelType !== undefined ? ` ${travelType === EMetroTravelType.MapFoot ? 'пешком' : 'транспортом'}` : ''
  }`;
}
